export default __webpack_public_path__ + "static/media/online-pk-5-banner-graphics.4d935fe4.svg";